export default "__VITE_ASSET__6AAJ0iJW__"